module.exports = __webpack_public_path__ + "static/lake_aerial_4-f4a18be2e8c8bbe3876cf3f1d09d4f82.jpg";